export default "__VITE_ASSET__jKWfWN7P__"